module.exports = __webpack_public_path__ + "img/某快时尚企业的营销战略.810068b4.png";